var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
var A = styled.a.attrs({ rel: 'noopener noreferrer', target: '_blank' })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: inherit;\n"], ["\n  color: inherit;\n"])));
var Box = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: inherit;\n  display: flexbox;\n  align-items: center;\n  justify-content: center;\n  padding: 5px 5px;\n  height: 100px;\n\n  @media (min-width: 201px) {\n    border-radius: 6px;\n  }\n"], ["\n  background-color: inherit;\n  display: flexbox;\n  align-items: center;\n  justify-content: center;\n  padding: 5px 5px;\n  height: 100px;\n\n  @media (min-width: 201px) {\n    border-radius: 6px;\n  }\n"])));
export function LinkedInShareButton(props) {
    var href = 'https://www.linkedin.com/shareArticle?mini=true&url=' + props.url;
    return (_jsx(Box, { children: _jsx(A, __assign({ href: href }, { children: "Share on LinkedIn" }), void 0) }, void 0));
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=ShareButton.js.map